<template>
	<div class="space">
		<div class="tab-list">
			<div class="mid">
				<span>分组管理</span>
				<el-button type="primary" class="add-group fr" size="small" @click="addGroupPop('')">新增分组</el-button>
			</div>
		</div>
		<div class="content">
			<el-table :data="groupData" style="width: 100%">
				<el-table-column type="expand" prop="teacherList">
					<template slot-scope="props">
						<el-row type="flex" justify="space-around">
							<el-col :span="20">
								<el-tag class="tag" v-for="i in props.row.teacherList" :key="i.teacherId" closable @close="handleCloseTag(props.row.groupCode,i.teacherId)">{{i.teacherName}}</el-tag>
							</el-col>
							<el-col :span="2">
								<el-button type="text" size="small" @click="addTeacherPop(props.row)">添加老师</el-button>
							</el-col>
						</el-row>
					</template>
				</el-table-column>
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column label="组名" prop="groupName"></el-table-column>
				<el-table-column label="创建时间" prop="createTime"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="props">
						<el-button type="text" @click="addTeacherPop(props.row)">添加教师</el-button>
						<el-button type="text" @click="addGroupPop(props.row)">编辑</el-button>
						<el-button type="text" class="del-btn" @click="delGroupPop(props.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination :pageObj="pageObj" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
		</div>
		<!-- 新增分组的弹框 -->
		<el-dialog title="新增分组" class="group-pop" :visible.sync="isShowGroup" width="500px" center>
			<div class="transfer-box1">
				<span>分组名称：</span>
				<el-input style="width: 250px;" clearable placeholder="请输入" v-model="form.groupName" maxlength="20" show-word-limit></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="cancelGroup">取 消</el-button>
				<el-button type="primary" @click="addOkGroup">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 添加教师 -->
		<join-pop @close="closeJoinPop" @joinUsersChange="userChange" :showJoinPop="showJoinPop" v-if="showJoinPop"></join-pop>
		<!-- 删除的对话框 -->
		<popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
	</div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapGetters, mapState } from "vuex";
import { mapFileIcon, lookFile, downloadUrlFile } from "@/utils/index.js";
import Pagination from "@/components/Pagination.vue";
import JoinPop from "@/components/common/JoinPop.vue";
export default {
	components: {
		Pagination,
		PopupDel,
		JoinPop
	},
	computed: {
		...mapGetters(["schoolCodes"]),
		...mapState(["userInfo", "resOptions"])
	},
	data() {
		return {
			curGroupInfo: "",
			groupName: "",
			isShowGroup: false,
			showJoinPop: false,
			delGroupCode: "",
			delVisible: false,
			btnLoading: false,
			isTableLoading: false,
			delTeachers: [],
			delType: "", //group teacher
			groupData: [],
			teacherList: [],

			rules: {},
			pageObj: {
				current: 1,
				total: 0,
				size: 10,
				sizeList: [5, 10, 15, 20]
			},
			form: {
				groupCode: "",
				groupName: "",
				operatorId: "",
				id: "",
				schoolCode: ""
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		mapFileIcon,
		lookFile,
		init() {
			this.groupList();
		},
		async groupList() {

			let { records, total } = await postJson(
				"/planning/getGroupManagementList",
				{
					operatorId: this.userInfo.userId,
					pageNum: this.pageObj.current,
					pageSize: this.pageObj.size,
					schoolCodes: this.schoolCodes
				}
			);
			this.pageObj.total = total;
			records.forEach(r => {
				if (!r.teacherList || r.teacherList.length === 0) {
					r.teacherList = [];
				}
			});
			this.groupData = records;
		},
		getTeacherList(groupCode) {
			postData("/planning/getGroupManagement", {
				groupCode: groupCode
			}).then(res => {
				let info = this.groupData.find(i => i.groupCode == groupCode);
				this.$set(info, "teacherList", res.teacherList);
			});
		},
		addGroupPop(row) {
			if (row) {
				this.form.groupName = row.groupName;
				this.form.groupCode = row.groupCode;
				this.form.id = row.id;
			} else {
				this.form.groupCode = "";
				this.form.groupName = "";
				this.form.id = "";
			}
			this.isShowGroup = true;
		},
		cancelGroup() {
			this.isShowGroup = false;
		},
		async addOkGroup() {
			if (this.form.groupName == "") {
				return this.$message.error("请填写分组名称！");
			} else {
				this.form.operatorId = this.userInfo.userId;
				this.form.schoolCode = this.userInfo.schoolCode;
				await postJson("/planning/saveOrUpdateGroupManagement", this.form);
				this.$message.success("新增分组成功！");
				this.cancelGroup();
				this.groupList();
			}
		},
		addTeacherPop(row) {
			this.curGroupInfo = row;
			this.showJoinPop = true;
		},
		closeJoinPop() {
			this.showJoinPop = false;
		},
		delGroupPop(row) {
			this.curGroupInfo = row;
			this.delVisible = true;
		},
		userChange(users) {
			let teacherList = users.map(i => {
				return {
					teacherId: i.userId,
					teacherName: i.userName
				};
			});
			postJson("/planning/saveGroupManagementUser", {
				groupCode: this.curGroupInfo.groupCode,
				groupName: this.curGroupInfo.groupName,
				operatorId: this.userInfo.userId,
				teacherList: teacherList
			}).then(res => {
				this.getTeacherList(this.curGroupInfo.groupCode);
			});
			this.isOtherUers = true;
		},
		handleCloseTag(groupCode, teacherId) {
			postData("/planning/deleteGroupManagementUser", {
				groupCode: groupCode,
				teacherId: teacherId
			}).then(res => {
				this.getTeacherList(groupCode);
			});
		},
		// 删除弹框 关闭
		async closePopupDel(status) {
			try {
				if (status) {
					await postData("/planning/deleteGroupManagement", {
						groupCode: this.curGroupInfo.groupCode
					});
					this.groupList();
					this.delVisible = false;
				} else {
					this.delVisible = false;
				}
			} catch (err) {
				console.log("err", err);
			}
		},
		handleSelectionChange() {},
		//分页
		handleSizeChange(pageSize) {
			this.pageObj.current = 1;
			this.pageObj.size = pageSize;
			this.groupList();
		},
		handleCurrentChange(curPage) {
			this.pageObj.current = curPage;
			this.groupList();
		}
	},
	watch: {}
};
</script>

<style lang="less" scoped>
.space {
	.tab-list {
		background-color: #fff;
		padding: 20px 0px;
		border-bottom: 2px solid #eee;
		.mid-group {
			padding: 0px 20px;
		}
		.add-group {
			margin-right: 70px;
			margin-top: -5px;
		}
		span {
			font-size: 17px;
			padding: 6px 8px;
			border-radius: 8px;
			margin-left: 100px;
			color: @color;
		}
	}
	.content {
		background-color: #fff;
		margin-top: 15px;
		padding: 10px 0px;
		.del {
			margin: 8px;
			margin-right: 60px;
		}
		.del-btn {
			color: @hong;
		}
		.tag {
			padding: 0px 5px;
			margin: 5px;
		}
	}
	.group-pop {
		/deep/.el-dialog--center {
			border-radius: 15px;
		}
		/deep/.el-dialog--center .el-dialog__body {
			padding: 0px 30px;
		}
		.transfer-box1 {
			padding: 40px;
			border: 1px solid rgb(231, 227, 227);
			border-radius: 5px;
			text-align: center;
		}
	}
}
</style>
